import { render, staticRenderFns } from "./slideControl.vue?vue&type=template&id=15898da5&"
import script from "./slideControl.vue?vue&type=script&lang=ts&"
export * from "./slideControl.vue?vue&type=script&lang=ts&"
import style0 from "./slideControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports